import { render, staticRenderFns } from "./SeatMapSga.vue?vue&type=template&id=0f54c470"
import script from "./SeatMapSga.vue?vue&type=script&lang=js"
export * from "./SeatMapSga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports